<template>
  <!-- Statistics Section -->
  <section class="statistics-section" id="stats">
    <div class="container">
      <h2 class="section-title">{{ locale === 'tr' ? 'İstatistiklerimiz' : 'Our Statistics' }}</h2>
      <p class="section-subtitle">{{ locale === 'tr' ? 'Başarılarımızı rakamlarla keşfedin' : 'Discover our achievements in numbers' }}</p>
      <div class="stats-grid">
        <div class="stat-item" v-for="(stat, index) in statItems" :key="index">
          <div class="stat-icon">
            <i v-if="stat.icon && stat.icon.startsWith('fas')" :class="stat.icon"></i>
            <span v-else>{{ stat.icon || '📊' }}</span>
          </div>
          <div class="stat-content">
            <div 
              class="stat-number" 
              :data-target="stat.value"
              ref="statNumbers"
            >
              0
            </div>
            <div class="stat-suffix">{{ stat.suffix }}</div>
            <div class="stat-label">{{ locale === 'tr' ? stat.label_tr : stat.label_en }}</div>
          </div>
        </div>
      </div>
      
      <!-- Debug info for statistics -->
      <div v-if="statItems.length === 0" class="stats-debug" style="text-align: center; padding: 20px; background: #f5f5f5; margin: 20px 0;">
        <p>📊 Debug: statItems.length = {{ statItems.length }}</p>
        <p>🔄 isLoadingData = {{ isLoadingData }}</p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { useStatistics } from '@/composables/useStatistics'

// Props
defineProps({
  locale: {
    type: String,
    default: 'tr'
  }
})

// Composable kullanımı
const { statItems, isLoadingData } = useStatistics()

// Template refs
const statNumbers = ref([])

// Statistics animation
const animateStats = () => {
  const numbers = statNumbers.value
  if (!numbers || numbers.length === 0) return

  numbers.forEach((numberElement) => {
    if (!numberElement) return
    
    const target = parseInt(numberElement.getAttribute('data-target'))
    const duration = 2000
    const increment = target / (duration / 16)
    let current = 0

    const updateNumber = () => {
      current += increment
      if (current < target) {
        numberElement.textContent = Math.ceil(current)
        requestAnimationFrame(updateNumber)
      } else {
        numberElement.textContent = target
      }
    }
    
    updateNumber()
  })
}

// Intersection Observer for animations
let statsObserver = null

onMounted(async () => {
  // DOM güncellemelerini bekle
  await nextTick()
  
  // Statistics Observer
  statsObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-stat')
          animateStats()
          statsObserver.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.5 }
  )

  // Observe statistics section
  const statsSection = document.querySelector('.statistics-section')
  if (statsSection && statsObserver) {
    statsObserver.observe(statsSection)
  }
})

onUnmounted(() => {
  if (statsObserver) {
    statsObserver.disconnect()
  }
})
</script>